<template>
  <div id="place-order-container" class="module-body" style="overflow: hidden">
    <v-tabs v-model="formConfig.current" background-color="#1d2b35" active-class="tab-active" style="height: 42px;">
      <v-tab v-for="(tab, index) in formConfig.list" :key="index">{{ tab.label }}</v-tab>
    </v-tabs>
    <!-- 目标 -->
    <v-tabs-items v-model="formConfig.current">
      <v-tab-item v-for="(tab, formIndex) in formConfig.list" class="h-100" :key="formIndex">
        <div class="trade-operate-container d-flex pa-2 py-2">
          <div
            class="trade-panel px-3"
            :class="index ? 'trade-sell-panel' : 'trade-buy-panel'"
            v-for="(tabItem, index) in tab.list"
            :key="index"
          >
            <div class="trade-panel-head">
              <!-- 未登录提示 -->
              <LoginTips></LoginTips>
              <v-divider class="mt-2 mb-2" color="#212b42" v-show="!Getter_Token"></v-divider>
              <!-- 买入 -->
              <div class="can-use-money-box mb-2" v-show="Getter_Token">
                <div class="d-flex justify-space-between align-center">
                  <span class="can-use-money" v-if="index == 1" style="font-size: 14px">
                    {{ $t('labels.finance.available') }}:
                    <span
                      class="color-090"
                    >{{ userAccountData.buyAmount || '--' }}</span>
                    {{ formConfig.coin || '--' }}
                  </span>
                  <span class="can-use-money" v-if="index == 0" style="font-size: 14px">
                    {{ $t('labels.finance.available') }}:
                    <span
                      class="color-090"
                    >{{ userAccountData.sellAmount || '--' }}</span>
                    {{ formConfig.marketCoin || '--' }}
                  </span>
                  <router-link
                    to="/coin-to-coin-account"
                    class="recharge-link"
                  >{{ $t('actions.deposit') }}</router-link>
                </div>
              </div>
            </div>
            <!--  买入价  -->
            <div class="trade-panel-body" v-if="Getter_Current_Market">
              <div class="trade-form">
                <div class="form-item d-flex mb-3">
                  <label class="trade-form-label">{{ tabItem.name }}{{ $t('labels.trade.price') }}</label>
                  <div class="trade-form-input" style="position: relative">
                    <PlaceOrderInput
                      :ref="`price${tabItem.ref}`"
                      :refs="tabItem.ref"
                      v-model="formConfig.list[formIndex].list[index].price"
                      :placeholder="
                        tab.value === 'free'
                          ? '以市场上最优价格交易'
                          : tabItem.name + $t('labels.trade.price') + ' ' + '(' + formConfig.marketCoin + ')'
                      "
                      :maxlength="16"
                      :maxdecimal="Getter_Current_Market.priceDec"
                      @inputChg="convertCurrency"
                      @showCurrentCurrencyBottom="showConvertCurrency"
                      @hideCurrentCurrencyBottom="hideConvertCurrency"
                    ></PlaceOrderInput>

                    <div class="math-price" v-if="tab.value !== 'free' && buyConvertCurrency && tabItem.ref == 'Buy'" style="position:absolute;width: 100%;z-index: 3">
                      ≈
                      <!-- {{index == 1 ? coinConvertToCurrency_sell(tabItem.name) :
                      coinConvertToCurrency_buy(tabItem.name)}}-->
                      {{ buyPrice }}
                      {{ Getter_Current_Currency.abbreviation || '--' }}
                    </div>
                    <div class="math-price" v-if="tab.value !== 'free' && sellConvertCurrency && tabItem.ref == 'Sell'" style="position:absolute;width: 100%;z-index: 3">
                      ≈
                      <!-- {{index == 1 ? coinConvertToCurrency_sell(tabItem.name) :
                      coinConvertToCurrency_buy(tabItem.name)}}-->
                      {{ sellPrice }}
                      {{ Getter_Current_Currency.abbreviation || '--' }}
                    </div>
                  </div>
                </div>

                <!--  买入量  -->
                <div class="form-item d-flex mb-3">
                  <label class="trade-form-label">{{ tabItem.name }}{{ $t('labels.trade.vol') }}</label>
                  <div class="trade-form-input">
                    <PlaceOrderInput
                      :ref="`volume${tabItem.ref}`"
                      v-model="formConfig.list[formIndex].list[index].volume"
                      :placeholder="tabItem.name + $t('labels.trade.vol') + ' ' + '(' + formConfig.coin + ')'"
                      :maxlength="16"
                      :maxdecimal="Getter_Current_Market.volDec"
                    ></PlaceOrderInput>
                  </div>
                </div>
                <!--滚动条-->
                <!--<div class="form-item">
                    <label class="trade-form-label slide-label">&nbsp;</label>
                    <div class="trade-form-input trade-slider-wrap relative-position">
                      <q-slider
                        v-model="tabItem.sliderValue"
                        class="trade-slider"
                        :min="0"
                        :max="100"
                        :step="0.1"
                        :label-value="`${tabItem.sliderValue.toFixed(2)}%`"
                        :disable="tabItem.canBuyVolume === 0"
                        @input="_buySliderInputEvent"
                        label
                      />
                      <ul class="slider-point-list">
                        <template v-for="item in formConfig.slideItem">
                          <li :key="item" class="slide-point-item" :class="{cover: item.sliderValue >= 0}"
                              :data-value="item" :title="`${item}%`"></li>&nbsp;
                        </template>
                      </ul>
                      <div class="amount-range clearfix">
                        <span class="min-amount">0 {{formConfig.coin || '&#45;&#45;'}}</span>
                        <div class="max-amount float-right">{{tabItem.canBuyVolume}} {{formConfig.coin || '&#45;&#45;'}}</div>
                      </div>
                    </div>
                </div>-->
                <!--  交易额  -->
                <div class="form-item d-flex mb-2">
                  <!-- <label class="trade-form-label">&nbsp;</label> -->
                  <div class="trade-total-money">
                    <span class="expected-trade-amount-label">{{ $t('labels.trade.amt') }}</span>
                    <span
                      v-if="Getter_Current_Market.priceDec >= 0 && Getter_Current_Market.volDec >= 0"
                      class="expected-trade-amount"
                    >{{ totalAmount(tabItem.ref) }} {{ formConfig.marketCoin || '--' }}</span>
                  </div>
                </div>
                <!--  买入按钮-->
                <div
                  class="form-item no-mb d-flex justify-end"
                  :class="{ 'btn-disabled-wrapper': !Getter_Token || 0 == Getter_Current_Market.tradeStatus }"
                >
                  <label class="trade-form-label">&nbsp;</label>
                  <v-btn
                    v-if="index == 0"
                    :loading="tabItem.committing"
                    :disabled="!Getter_Token || 0 == Getter_Current_Market.tradeStatus"
                    :class="{ disabled: !Getter_Token }"
                    @click="buyBtnClick"
                    class="order-btn buy-btn"
                    large
                  >{{ `${tabItem.name} ${formConfig.coin || '--'}` }}</v-btn>
                  <v-btn
                    v-else
                    :loading="tabItem.committing"
                    :disabled="!Getter_Token || 0 == Getter_Current_Market.tradeStatus"
                    :class="{ disabled: !Getter_Token }"
                    @click="sellBtnClick"
                    class="order-btn sell-btn"
                    large
                  >{{ `${tabItem.name} ${formConfig.coin || '--'}` }}</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <div class="exchange-loading" v-if="loading">
      <div class="loading-inner">
        <v-progress-circular class="mr-1" color="#ffffff" indeterminate size="40"></v-progress-circular>
        <span class="loading-text">{{ $t('labels.loading') }}...</span>
      </div>
    </div>

    <TxnPwdModal
      v-if="txnPwdModalShow"
      @submit="submitOrder"
      @closeTxnPwd="closeTxnPwd"
      :show.sync="txnPwdModalShow"
      :title="$t('labels.txnPwd')"
      :data="txnPwdModalData"
      :flag="warningWord"
      :percentage="percentage"
      :loading="loading"
    />
  </div>
</template>

<script>
// import VuePopover from '../../components/popover/VuePopover.vue';
import LoginTips from './LoginTips.vue';
import { mutationTypes } from '@/store/mutation-types.js';
import { mapGetters, mapMutations } from 'vuex';
import { getterTypes as getters, getterTypes } from '@/store/getter-types';
import { tradeApi } from '@/api/exchange.page';
import { assetsApi } from '@/api/assetsApi';
import TxnPwdModal from '@/components/TxnPwdModal2';
import md5 from 'js-md5';
import tool from '@/common/js/tool';
import math from 'mathjs';
import PlaceOrderInput from './components/placeorder-input';
import BigNumber from 'bignumber.js';

let bigMath = math.create({
  number: 'BigNumber'
});
export default {
  name: 'PlaceOrder',
  metaInfo: {
    title: '专业版交易'
  },
  props: {
    accountData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    price: {
      type: String,
      default: null
    },
    volume: {
      type: String,
      default: null
    },
    bestPrice: {
      type: Object,
      default: null
    }
  },
  components: {
    // VuePopover,
    LoginTips,
    TxnPwdModal,
    PlaceOrderInput
  },
  data() {
    return {
      loading: false,
      formConfig: {
        slideItem: [0, 25, 50, 75, 100],
        coin: '',
        marketCoin: '',
        c: '',
        aviAmount: '',
        current: 1,
        list: [
          // 限价
          {
            label: this.$t('labels.trade.limit'),
            value: 'limit',
            list: [
              {
                pricePopover: {},
                volumePopover: {},
                value: 0,
                price: 0,
                volume: 0,
                tradeAmount: 0,
                name: this.$t('labels.trade.buy'),
                ref: 'Buy',
                exchange: { amount: 0, unit: 'USDT', value: 0 },
                sliderValue: 0,
                btn: { unit: 'BTC', amount: '' }
              },
              {
                pricePopover: {},
                volumePopover: {},
                value: 0,
                price: 0,
                volume: 0,
                tradeAmount: 0,
                name: this.$t('labels.trade.sell'),
                ref: 'Sell',
                exchange: { amount: 0, unit: 'USDT', value: 0 },
                sliderValue: 1,
                btn: { unit: 'USDT', amount: '' }
              }
            ]
          }
          // 市价
          /* {
              label: '市价交易',
              value: 'free',
              list: [
                {
                  pricePopover: {},
                  volumePopover: {},
                  value: 0,
                  name: '买入',
                  avi: { amount: 0, unit: 'USDT' },
                  exchange: { amount: 0, unit: 'USDT', value: 0 },
                  sliderValue: 0,
                  btn: { unit: 'USDT', amount: '' },
                },
                {
                  pricePopover: {},
                  volumePopover: {},
                  value: 0,
                  name: '卖出',
                  exchange: { amount: 0, unit: 'USDT', value: 0 },
                  sliderValue: 0,
                  btn: { unit: 'USDT', amount: '' },
                },
              ],
            } */
        ]
      },
      txnPwdModalShow: false,
      txnPwdModalData: {},
      txnPwd: '',
      rememberPwd: false,
      userAccountData: {
        buyAmount: 0, // 买入可用余额
        buyLockAmount: 0, // 买入冻结余额
        buyUnit: '', // 买入单位
        sellAmount: 0, // 卖出可用余额
        sellLockAmount: 0, // 卖出冻结余额
        sellUnit: '' // 卖出单位
      },
      // 用户账号数据(交易面板数据)
      // userAccountData: {
      //   buyAmount: 0, // 买入可用余额
      //   buyLockAmount: 0, // 买入冻结余额
      //   buyUnit: '', // 买入单位

      //   sellAmount: 0, // 卖出可用余额
      //   sellLockAmount: 0, // 卖出冻结余额
      //   sellUnit: '', // 卖出单位
      // },
      // lastBuyPrice: 0,
      // lastSellPrice: 0,
      warningWord: false,
      percentage: '',
      priceHasInit: false,
      buyConvertCurrency: false,
      sellConvertCurrency: false,
    };
  },
  computed: {
    ...mapGetters([
      getterTypes.Getter_Current_Market,
      getterTypes.Getter_Current_Currency,
      getterTypes.Getter_Token,
      getterTypes.Getter_User_Info
    ]),
    // 计算币种转换成法币(真实货币)后的价格
    coinConvertToCurrency_buy() {
      let buyPrice = this.formConfig.list[0].list[0].price;
      if (isNaN(Number(buyPrice))) {
        return '0.00';
      }
      // 币种转法币规则：买入价 * 币种转换成usdt后的价格 * 当前法币的买入汇率
      let price = buyPrice * this.Getter_Current_Currency.rate;
      // let decimal = this.this.Getter_Current_Market.priceDec;
      return this.limitDecimal(price, 2) * 1;
    },
    // 计算币种转换成法币(真实货币)后的价格
    coinConvertToCurrency_sell() {
      let sellPrice = this.formConfig.list[0].list[1].price;
      if (isNaN(Number(sellPrice))) {
        return '0.00';
      }
      // 币种转法币规则：买入价 * 币种转换成usdt后的价格 * 当前法币的买入汇率
      let price = sellPrice * this.Getter_Current_Currency.rate;
      // let decimal = this.this.Getter_Current_Market.volDec;

      return this.limitDecimal(price, 2);
    },
    buyPrice() {
      let price = this.formConfig.list[0].list[0].price;
      let currencyPrice = this.coinConvertToCurrency(price);
      return currencyPrice;
    },
    sellPrice() {
      let price = this.formConfig.list[0].list[1].price;
      let currencyPrice = this.coinConvertToCurrency(price);
      return currencyPrice;
    }
  },
  watch: {
    Getter_Current_Market() {
      this.init(true /** marketChg */);
      if (this.Getter_Token) {
        this.getUserAccountData();
      }
    },
    accountData() {
      if (this.Getter_Token) {
        this.getUserAccountData();
      }
    },
    txnPwdModalShow(val) {
      this.txnPwd = '';
    },
    price(value) {
      console.log('value--->', value);
      if (value) {
        // this.$refs.priceBuy[0].model = value;
        // this.$refs.priceSell[0].model = value;
        this.formConfig.list[0].list[0].price = value;
        this.formConfig.list[0].list[1].price = value;
        // this.$refs.volumeBuy[0].clear();
        // this.$refs.volumeSell[0].clear();
      }
    },
    volume(value) {
      if (value) {
        this.formConfig.list[0].list[0].volume = value;
        this.formConfig.list[0].list[1].volume = value;
      }
    },
    bestPrice(value) {
      if (!this.isEmpty(this.bestPrice) && (this.bestPrice.bestBuy || this.bestPrice.bestSell)) {
        if (!this.priceHasInit) {
          this.initPrice(value);
        }
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.SET_CURRENTMARKET]),
    // Getter_Current_Currency () {},
    init(marketChg = false) {
      this.priceHasInit = false;
      let currentMarket = this.Getter_Current_Market;
      this.priceMin = currentMarket.priceMin;
      this.priceMax = currentMarket.priceMax;
      this.formConfig.coin = currentMarket.coin;
      this.formConfig.marketCoin = currentMarket.marketCoin;
      // limit - buy
      this.formConfig.list[0].list[0].price = null;
      this.formConfig.list[0].list[0].volume = 0;
      // limit - sell
      this.formConfig.list[0].list[1].price = null;
      this.formConfig.list[0].list[1].volume = 0;
      if (!this.isEmpty(this.bestPrice) && (this.bestPrice.bestBuy || this.bestPrice.bestSell)) {
        // if marketChg == true, let the watch update bestBuy & bestSell
        if (!this.priceHasInit && !marketChg) {
          this.initPrice(this.bestPrice);
        }
      }
      if (this.Getter_Token) {
        if (!this.isEmpty(this.accountData)) {
          this.getUserAccountData();
        }
      }
    },
    initPrice(value) {
      this.formConfig.list[0].list[0].price = value.bestBuy;
      this.formConfig.list[0].list[1].price = value.bestSell;
      this.priceHasInit = true;
    },
    totalAmount(name) {
      let amount = new BigNumber(0);
      let price = 0,
        volume = 0;
      if (name === 'Buy') {
        price = this.formConfig.list[0].list[0].price;
        volume = this.formConfig.list[0].list[0].volume;
      } else if (name === 'Sell') {
        price = this.formConfig.list[0].list[1].price;
        volume = this.formConfig.list[0].list[1].volume;
      }
      if (price && volume) {
        try {
          amount = new BigNumber(price).times(new BigNumber(volume));
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
      amount = amount.toFixed(this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec);
      return amount;
    },
    // totalAmount(name) {
    //   let amount = new BigNumber(0);
    //   let price = this.$refs[`price${name}`];
    //   let volume = this.$refs[`volume${name}`];
    //   if (price && volume) {
    //     if (price[0].model && volume[0].model) {
    //       try {
    //         amount = new BigNumber(price[0].model).times(new BigNumber(volume[0].model));
    //       } catch (error) {
    //         console.error(error);
    //         throw error;
    //       }
    //     }
    //   }
    //   amount = amount.toFixed(this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec);
    //   return amount;
    // },
    convertCurrency(value, type) {
      //   console.log('value', value);
      //   if (type === 'Buy') {
      //     console.log('this.formConfig.list[0].list[0].price', this.formConfig.list[0].list[0].price);
      //     // this.formConfig.list[0].list[0].price = value;
      //   } else if (type === 'Sell') {
      //     console.log('this.formConfig.list[0].list[1].price', this.formConfig.list[0].list[1].price);
      //     // this.formConfig.list[0].list[1].price = value;
      //   }
    },
    coinConvertToCurrency(value) {
      let price = new BigNumber(0);

      if (value) {
        try {
          price = new BigNumber(value).times(new BigNumber(this.Getter_Current_Currency.rate));
        } catch (error) {
          console.error(error);
          throw error;
        }
      }

      return price.toFixed(2, BigNumber.ROUND_DOWN);
    },
    // coinConvertToCurrency(name) {
    //   // setTimeout(() => {
    //     console.log('name', name);
    //     let target = this.$refs[`price${name}`];
    //     console.log('target', target);
    //     let price = new BigNumber(0);

    //     if (target) {
    //       if (!target[0].model) {
    //         price = new BigNumber(0);
    //       } else {
    //         try {
    //           price = new BigNumber(target[0].model).times(new BigNumber(this.Getter_Current_Currency.rate));
    //         } catch (error) {
    //           console.error(error);
    //           throw error;
    //         }
    //       }
    //     }

    //     return price.toFixed(2, BigNumber.ROUND_DOWN);
    //   // }, 1000);
    // },
    priceFocusEvent(tab, index) {
      if (tab.value == 'limit') {
        if (this.formConfig.list[0].list[index].price == 0) {
          this.formConfig.list[0].list[index].price = '';
        }
        if (this.formConfig.list[0].list[index].price == 0) {
          this.formConfig.list[0].list[index].price = '';
        }
      }
    },
    volumeFocusEvent(tab, index) {
      if (tab.value == 'limit') {
        if (this.formConfig.list[0].list[index].volume == 0) {
          this.formConfig.list[0].list[index].volume = '';
        }
        if (this.formConfig.list[0].list[index].volume == 0) {
          this.formConfig.list[0].list[index].volume = '';
        }
      }
    },
    // sellPriceFocusEvent() {
    //   if (this.formConfig.list[1].price == 0) {
    //     this.formConfig.list[1].price = '';
    //   }
    // },
    // priceInputEvent(index, e) {
    //   e = e || window.event;
    //   let target = e.target || e.srcElement;
    //   let val = target.value;

    //   if (/\.$/.test(val) || (this.formConfig.list[0].list[index].tradeAmount + '').length === 0) {
    //     return;
    //   }
    //   if (isNaN(Number(val))) {
    //     this.formConfig.list[0].list[index].price = 0;
    //   }

    //   if ((val + '').length === 0) {
    //     val = 0;
    //   }
    //   val = this.limitDecimal(this.formConfig.list[0].list[index].price, this.Getter_Current_Market.priceDec);

    //   this.formConfig.list[0].list[index].price = val;

    //   this.computedAmount(index, this.formConfig.list[0].list[index].price);
    // },
    // volumeInputEvent(index, e) {
    //   return;
    //   // let currentBuyItem = this.currentBuyItem;
    //   if (/\.$/.test(val) || (val + '').length === 0) {
    //   }
    //   /* 不能对整数位进行截取，不管是从低位往高位截还是高位往地位截 */

    //   // val = this.limitInt(val, 8);
    //   val = this.limitDecimal(val, this.Getter_Current_Market.volDec);

    //   if (/\.$/.test(val) || (val + '').length === 0) {
    //   }
    //   if (isNaN(Number(val))) {
    //     this.formConfig.list[0].list[index].volume = 1;
    //   }
    //   // currentBuyItem.amount = val;
    //   // target.value = val;
    //   this.formConfig.list[0].list[index].volume = val;

    //   this.computedAmount(index, this.formConfig.list[0].list[index].price);
    // },
    // 计算购买量
    // computedAmount(index, price) {
    //   let { priceDec, volDec } = this.Getter_Current_Market;

    //   this.formConfig.list[0].list[index].price = price;
    //   if (price > 0) {
    //     if (
    //       this.isUndefinedOrNullOrEmpty(this.formConfig.list[0].list[index].volume) ||
    //       isNaN(this.formConfig.list[0].list[index].volume)
    //     ) {
    //       this.formConfig.list[0].list[index].volume = 1;
    //     }

    //     /* 对最大可买量进行格式化，否则计算买入量比例时会不正确。如果userAccountData.buyAmount小数点过多，价格过大，则会
    //      * 造成canBuyAmount为科学计数法，从而导致canBuyAmount计算错误，因为需要toNonExponential进行转换 */
    //     let canBuyAmount = this.toNonExponential(this.userAccountData.buyAmount / price);
    //     /* 不能对整数位进行截取，不管是从低位往高位截还是高位往地位截 */
    //     canBuyAmount = this.limitDecimal(canBuyAmount, volDec);
    //     if (isNaN(Number(canBuyAmount)) || canBuyAmount === 'Infinity') {
    //       canBuyAmount = 0;
    //     }
    //     // this.currentBuyItem.canBuyAmount = canBuyAmount;

    //     // 如果买入量大于最大可卖量，则买入量等于最大可买量
    //     if (this.formConfig.list[0].list[index].volume * 1 > canBuyAmount * 1) {
    //       // 如果这里做限制则会出现钱不够时，买入量无法输入问题
    //       // currentBuyItem.amount = canBuyAmount;
    //     }

    //     // this.sliderRateData.buy = Math.round(currentBuyItem.amount / canBuyAmount * 100);
    //     // 不能使用toFixed，因为toFixed会四舍五入
    //     // this.sliderRateData.rateBuyAmount = (currentBuyItem.amount * price).toFixed(priceScale);

    //     // this.sliderRateData.rateBuyAmount = this.limitDecimal(currentBuyItem.amount * price, priceScale);

    //     // 解决js精度丢失问题
    //     this.formConfig.list[0].list[index].tradeAmount = this.limitDecimal(
    //       bigMath.eval(`${this.formConfig.list[0].list[index].volume} * ${price}`).valueOf(),
    //       this.getPrecision(3)
    //     );
    //   } else {
    //     // currentBuyItem.canBuyAmount = 0;
    //     // this.sliderRateData.buy = 0;
    //     // this.sliderRateData.rateBuyAmount = 0;
    //   }
    //   // 如果有computedBuySliderLeft方法则说明是专业版交易页面
    //   /* if (typeof this.computedBuySliderLeft === 'function') {
    //       this.computedBuySliderLeft();
    //     } */
    // },
    // _buySliderInputEvent() {},
    // _sellSliderInputEvent() {},
    // Getter_Token () {},
    userSetupChecking() {
      const userInfo = this.Getter_User_Info;
      if (userInfo) {
        if (userInfo.gaStatus !== 1) {
          this.errorNotify(this.$t('v.common.setup.ga.before.trade'));
          return false;
        }
        if (userInfo.paymentPasswordStatus !== 1) {
          this.errorNotify(this.$t('v.common.setup.txnPwd.before.trade'));
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    buyBtnClick() {
      if (!this.userSetupChecking()) {
        return;
      }
      let buyData = this.formConfig.list[0].list[0];
      buyData.price = this.formConfig.list[0].list[0].price;
      buyData.volume = this.formConfig.list[0].list[0].volume;
      buyData.tradeAmount = this.totalAmount('Buy');
      if (buyData.price == undefined || buyData.price <= 0) {
        this.errorNotify(this.$t('v.trade.price.required'));
        return false;
      }

      if (this.priceMin != 0 && Number(this.priceMin) > buyData.price) {
        this.errorNotify(this.$t('v.trade.price.min').replace('{priceMin}', Number(this.priceMin)));
        return;
      }

      if (this.priceMax != 0 && Number(this.priceMax) < buyData.price) {
        this.errorNotify(this.$t('v.trade.price.max').replace('{priceMax}', Number(this.priceMax)));
        return;
      }

      if (buyData.volume == undefined || buyData.volume <= 0) {
        this.errorNotify(this.$t('v.trade.volume.required'));
        return false;
      }

      if (Number(buyData.tradeAmount) > Number(this.userAccountData.sellAmount)) {
        this.errorNotify(this.$t('v.trade.amount.insufficientBalance'));
        return false;
      }
      if (
        this.bestPrice.bestBuy !== undefined &&
        this.bestPrice.bestBuy != 0 &&
        !isNaN(this.bestPrice.bestBuy) &&
        !this.txnPwdModalShow
      ) {
        let lastSellPrice = this.bestPrice.bestBuy * 1.5;
        this.percentage = '50%';
        if (lastSellPrice > 0 && buyData.price > lastSellPrice) {
          let modalData = {
            volume: buyData.volume,
            price: buyData.price,
            side: 1 /* buy */,
            orderType: 1,
            txnPwd: this.txnPwd
          };
          this.txnPwdModalShow = true;
          this.warningWord = true;
          this.txnPwdModalData = modalData;
          return;
        }
      }

      this.txnPwd = window.localStorage.getItem('txnpwd') ? window.localStorage.getItem('txnpwd') : this.txnPwd;

      if (this.isUndefinedOrNullOrEmpty(this.txnPwd)) {
        let modalData = {
          volume: buyData.volume,
          price: buyData.price,
          side: 1 /* buy */,
          orderType: 1,
          txnPwd: this.txnPwd
        };
        this.txnPwdModalShow = true;
        this.txnPwdModalData = modalData;
        return false;
      } else {
        this.txnPwdModalShow = false;
        buyData.txnPwd = this.txnPwd;
      }

      this.placeOrder(1 /* buy */, buyData);
    },
    sellBtnClick() {
      if (!this.userSetupChecking()) {
        return;
      }

      let sellData = this.formConfig.list[0].list[1];

      sellData.price = this.formConfig.list[0].list[1].price;
      sellData.volume = this.formConfig.list[0].list[1].volume;
      sellData.tradeAmount = this.totalAmount('Sell');

      if (sellData.price == undefined || sellData.price <= 0) {
        this.errorNotify(this.$t('v.trade.price.required'));
        return false;
      }

      if (sellData.volume == undefined || sellData.volume <= 0) {
        this.errorNotify(this.$t('v.trade.volume.required'));
        return false;
      }

      if (this.priceMin != 0 && Number(this.priceMin) > sellData.price) {
        this.errorNotify(this.$t('v.trade.price.min').replace('{priceMin}', Number(this.priceMin)));
        return;
      }

      if (this.priceMax != 0 && Number(this.priceMax) < sellData.price) {
        this.errorNotify(this.$t('v.trade.price.max').replace('{priceMax}', Number(this.priceMax)));
        return;
      }

      if (Number(sellData.volume) > Number(this.userAccountData.buyAmount)) {
        this.errorNotify(this.$t('v.trade.amount.insufficientBalance'));
        return false;
      }
      if (
        this.bestPrice.bestSell !== undefined &&
        this.bestPrice.bestSell != 0 &&
        !isNaN(this.bestPrice.bestSell) &&
        !this.txnPwdModalShow
      ) {
        let lastBuyPrice = this.bestPrice.bestSell * 0.5;
        this.percentage = '50%';
        if (lastBuyPrice > 0 && lastBuyPrice > sellData.price) {
          let modalData = {
            volume: sellData.volume,
            price: sellData.price,
            side: 2 /* sell */,
            orderType: 1,
            txnPwd: this.txnPwd
          };
          this.txnPwdModalShow = true;
          this.warningWord = true;
          this.txnPwdModalData = modalData;
          return;
        }
      }

      this.txnPwd = window.localStorage.getItem('txnpwd') ? window.localStorage.getItem('txnpwd') : this.txnPwd;

      if (this.isUndefinedOrNullOrEmpty(this.txnPwd)) {
        // window.localStorage.setItem('txnpwd', this.txnPwd);
        let modalData = {
          volume: sellData.volume,
          price: sellData.price,
          side: 2 /* sell */,
          orderType: 1
          // txnPwd: this.txnPwd,
        };
        this.txnPwdModalShow = true;
        this.txnPwdModalData = modalData;
        return false;
      } else {
        this.txnPwdModalShow = false;
        sellData.txnPwd = this.txnPwd;
      }

      this.placeOrder(2 /* sell */, sellData);
    },
    placeOrder(type, data) {
      let _data = {
        pair: this.Getter_Current_Market.symbol,
        side: type /* 1 = buy, 2 = sell */,
        price: data.price,
        volume: data.volume,
        orderType: 1 /* limit order */,
        txnPwd: data.txnPwd
      };
      this.warningWord = false;
      this.loading = true;
      this.percentage = '';

      return tradeApi
        .placeOrder(_data)
        .then(res => {
          this.successNotify(this.$t('success.order.place'));
          if (!window.localStorage.getItem('txnpwd')) {
            if (this.rememberPwd) {
              window.localStorage.setItem('txnpwd', _data.txnPwd);
            }
          }
          this.rememberPwd = false;
          this.formConfig.list[0].list[0].price = '';
          this.formConfig.list[0].list[0].volume = '';
          this.formConfig.list[0].list[0].tradeAmount = 0;
          this.formConfig.list[0].list[1].price = '';
          this.formConfig.list[0].list[1].volume = '';
          this.formConfig.list[0].list[1].tradeAmount = 0;
          this.txnPwd = '';
          this.$emit('cleanPrice', '');
          this.$emit('cleanVolume', '');

          // this.$refs.priceBuy[0].clear();
          // this.$refs.volumeBuy[0].clear();
          // this.$refs.priceSell[0].clear();
          // this.$refs.volumeSell[0].clear();

          this.$emit('getUserAccountData');
          this.loading = false;
          return;
        })
        .catch(error => {
          /*if (error.errcode !== '1122'/!*invalid transaction password*!/) {
            if (!window.localStorage.getItem('txnpwd')) {
              if (this.rememberPwd) {
                window.localStorage.setItem('txnpwd', _data.txnPwd);
              }
            }
          }*/
          this.loading = false;
        });
    },
    setTxnPwd() {
      if (this.isUndefinedOrNullOrEmpty(this.txnPwd)) {
        this.txnPwdModalShow = true;
        return false;
      } else {
        this.txnPwdModalShow = false;
        return true;
      }
    },
    submitOrder(data, val) {
      this.rememberPwd = false;
      if (val) {
        this.rememberPwd = true;
      }
      this.txnPwdModalShow = false;
      data.txnPwd = md5(data.txnPwd);
      this.placeOrder(data.side, data);
    },
    /*async getUserAccountData() {
      for (let item of this.accountData) {
        if (item.symbol == this.formConfig.coin) {
          this.userAccountData.buyAmount = this.decimalRetain(item.available, 8); // 买入可用余额
          this.userAccountData.buyLockAmount = item.LockPos; // 买入冻结余额
        }
        if (item.symbol == this.formConfig.marketCoin) {
          this.userAccountData.sellAmount = this.decimalRetain(item.available, 8); // 买入可用余额
          this.userAccountData.sellLockAmount = item.LockPos; // 买入冻结余额
        }
      }
    },*/
    async getUserAccountData() {
      this.getAccountBuyAmount();
      this.getAccountSellAmount();
    },
    getAccountBuyAmount() {
      for (let item of this.accountData) {
        if (item.symbol == this.formConfig.coin) {
          this.userAccountData.buyAmount = this.decimalRetain(item.available, 8); // 买入可用余额
          this.userAccountData.buyLockAmount = item.LockPos; // 买入冻结余额
          return;
        } else {
          this.userAccountData.buyAmount = null ;
          this.userAccountData.buyLockAmount = null;
        }
      }
    },
    getAccountSellAmount() {
      for (let item of this.accountData) {
        if (item.symbol == this.formConfig.marketCoin) {
          this.userAccountData.sellAmount = this.decimalRetain(item.available, 8); // 买入可用余额
          this.userAccountData.sellLockAmount = item.LockPos; // 买入冻结余额
          return;
        } else {
          this.userAccountData.sellAmount = null;
          this.userAccountData.sellLockAmount = null;
        }
      }
    },
    getPrecision(flag /* 1 = priceDec, 2 = volDec */) {
      if (this.Getter_Current_Market) {
        if (flag === 1) {
          return this.Getter_Current_Market.priceDec;
        } else if (flag === 2) {
          return this.Getter_Current_Market.volDec;
        } else if (flag === 3) {
          /* return this.Getter_Current_Market.priceDec > this.Getter_Current_Market.volDec ?
              this.Getter_Current_Market.priceDec : this.Getter_Current_Market.volDec; */
          return this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec;
        }
      }
      return '';
    },
    closeTxnPwd() {
      this.warningWord = false;
    },
    showConvertCurrency(type) {
      if (type ==  'Buy') {
        this.buyConvertCurrency = true;
      }else if(type ==  'Sell') {
        this.sellConvertCurrency = true;
      }
      // console.log('hello world');
    },
    hideConvertCurrency(type) {
      if (type ==  'Buy') {
        this.buyConvertCurrency = false;
      }else if(type ==  'Sell') {
        this.sellConvertCurrency = false;
      }
    },
    limitDecimal: tool.limitDecimal,
    toNonExponential: tool.toNonExponential,
    decimalRetain: tool.decimalRetain
  },
  mounted() {
    if (!this.isEmpty(this.Getter_Current_Market)) {
      this.init();
    }
  }
};
</script>
<style lang="stylus" scoped>
@import './place-order.styl';
.module-body >>> .v-slide-group__wrapper {
  height:42px;
}
</style>

<style scoped>
.module-body >>> .v-tabs-items {
  height: 40.5%;
  background-color: #121d26;
}
</style>
